import { Link } from 'react-router';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/app/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="min-h-[calc(100vh-73px)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <div className="text-8xl font-bold text-white">
            404
          </div>
        </div>
        <h2 className="font-['Poppins',sans-serif] text-3xl font-semibold text-white mb-4">
          Page Not Found
        </h2>
        <p className="text-lg text-[#9595a5] mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/">
            <Button
              variant="outline"
              className="bg-transparent border-white/[0.08] text-white hover:bg-[#2a2a35]/50"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </Link>
          <Link to="/">
            <Button className="bg-white hover:opacity-90">
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}